  <!-- Action Bar -->
  <div class="wrapper-header sticky-header">
    <h1>{{title}}</h1>
    <div class="action-header-bar">
      <button matIconButton type="button" class="btn-action" (click)="onCancel()" matTooltip="Cancel" matTooltipPosition="above" aria-label="Cancel">
        <mat-icon class="material-symbols-outlined" fontIcon="cancel" />
      </button>
      <button matIconButton type="button" class="btn-action" (click)="onReset()" matTooltip="Reset" matTooltipPosition="above" aria-label="Reset">
        <mat-icon class="material-symbols-outlined" fontIcon="refresh"/>
      </button>
      <button matIconButton type="button" class="btn-action" (click)="onSave()" matTooltip="Save" matTooltipPosition="above" aria-label="Save">
        <mat-icon class="material-symbols-outlined" fontIcon="save" />
      </button>
      <!-- TODO uncomment when we implement these features -->
      <!-- <button matIconButton type="button" class="btn-action" (click)="onExport()" matTooltip="Export Instructions"
          matTooltipPosition="above" aria-label="Export Instructions">
          <mat-icon class="material-symbols-outlined">file_download</mat-icon>
        </button>
        <button matIconButton type="button" class="btn-action" (click)="onImport()" matTooltip="Import Instructions"
          matTooltipPosition="above" aria-label="Import Instructions">
          <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
        </button> -->
    </div>
  </div>

  <!-- Stepper -->
  <!-- Stepper component -->
  <app-utility-stepper [steps]="steps"
  [currentStep]="currentStep"
  [enableValidation]="validateOnRender"
  [validationStatus]="validationStatus"
  [isLinear]="false"
  (stepChange)="onStepChange($event)"
  (stepActivate)="onStepActivate($event)"
  (validationStatusChange)="onValidationStatusChange($event)">
    @for (step of steps; track step.label; let i = $index) {
      @if (currentStep === i) {
        @switch (step.label) {
          @case (InstructionStep.DEFINITION) {
            <app-instruction-definition></app-instruction-definition>
          }
          @case (InstructionStep.TYPES) {
            <app-instruction-types></app-instruction-types>
          }
          @case (InstructionStep.AI_CONFIG) {
            <app-instructions-ai-config></app-instructions-ai-config>
          }

          @case (InstructionStep.SECURITY) {
            <app-instruction-security></app-instruction-security>
          }

          @case (InstructionStep.ADMIN) {
            @if (showInstructionAdminStep) {
              <app-instruction-admin></app-instruction-admin>
            }
          }
          @case (InstructionStep.SUMMARY) {
            <app-instruction-summary></app-instruction-summary>
          }
        }
      }
    }
  </app-utility-stepper>
